import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { ApiKeyCreatePayload } from 'Interfaces/ApiKey';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: ApiKeyCreatePayload) =>
    $actions.apiKey.createApiKey(dispatch, payload),
  );
};
